var render = function render(){
  var _vm$value$thumb, _vm$value, _vm$value2, _vm$value2$meta, _vm$value2$meta$watch, _vm$value2$meta$watch2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', _vm._b({
    attrs: {
      "outlined": ""
    }
  }, 'v-card', {
    to: _vm.to
  }, false), [_c('v-img', {
    staticClass: "grey-f7",
    attrs: {
      "src": (_vm$value$thumb = _vm.value.thumb) === null || _vm$value$thumb === void 0 ? void 0 : _vm$value$thumb.src,
      "aspect-ratio": 16 / 9,
      "content-class": "d-flex flex-column justify-start"
    },
    scopedSlots: _vm._u([{
      key: "placeholder",
      fn: function () {
        return [_c('v-layout', {
          attrs: {
            "justify-center": "",
            "align-center": "",
            "fill-height": ""
          }
        }, [_c('v-icon', {
          attrs: {
            "x-large": "",
            "color": "grey lighten-4"
          }
        }, [_vm._v("mdi-image-broken-variant")])], 1)];
      },
      proxy: true
    }])
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('card-badges', _vm._b({}, 'card-badges', {
    value: _vm.value
  }, false))], 1)], 1), _c('v-divider'), _c('v-row', {
    staticClass: "ma-0",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "pa-16 font-size-18 font-weight-bold text-truncate"
  }, [_vm._v(" " + _vm._s((_vm$value = _vm.value) === null || _vm$value === void 0 ? void 0 : _vm$value.subject) + " ")]), _c('v-col', {
    staticClass: "pa-16",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-chip', {
    attrs: {
      "small": "",
      "outlined": ""
    }
  }, [_vm._v(_vm._s((_vm$value2 = _vm.value) === null || _vm$value2 === void 0 ? void 0 : (_vm$value2$meta = _vm$value2.meta) === null || _vm$value2$meta === void 0 ? void 0 : (_vm$value2$meta$watch = _vm$value2$meta.watcherCount) === null || _vm$value2$meta$watch === void 0 ? void 0 : (_vm$value2$meta$watch2 = _vm$value2$meta$watch.format) === null || _vm$value2$meta$watch2 === void 0 ? void 0 : _vm$value2$meta$watch2.call(_vm$value2$meta$watch)) + "명 참여")])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }